import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import layout from './layout.json';
import LeadGenDialog from './LeadGenDialog';

class LeadGenList extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      row: {},
      showEditDialog: false
    };

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
  }

  onIconClicked( args ) {
    this.setState( {
      row: args.row,
      showEditDialog: true
    } );
  }

  onClose( e ) {
    this.setState( {
      showEditDialog: false
    } );
  }

  onSave( args ) {
    this.setState( { 
      row: args.row,
      showEditDialog: false
    } );
  }

  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations','Management']}>
        <ListContainer id='LeadGenList' title='Leadgen' layout={layout} selectedtab={1} onIconClicked={this.onIconClicked} row={this.state.row} />
        <LeadGenDialog show={this.state.showEditDialog} layout={layout} onClose={this.onClose} onSave={this.onSave} row={this.state.row} />
      </PageAuthorize>
    );
  }
}

export default LeadGenList;



// WEBPACK FOOTER //
// ./src/content/enterprise/leadgen/components/LeadGenList.js